// extracted by mini-css-extract-plugin
export default {"interview_question_header":"style_interview_question_header__wPGCU","interviewQuestionHeader":"style_interview_question_header__wPGCU"};